import {Component, Inject} from '@angular/core';
import {FormControl, FormGroup, Validators} from '@angular/forms';
import {ActivatedRoute, Router} from '@angular/router';
import {MagentoCustomerService} from '../../../../../../../services/magentocustomer.service';
import {RegistryService} from '../../../../../services/registry.service';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {environment} from '../../../../../../../environments/environment';
import {ReviewsService} from '../../../../../services/reviews.service';

@Component({
    selector: 'app-add-new-review-comment',
    templateUrl: './add-new-review-comment.component.html',
    styleUrls: ['./add-new-review-comment.component.css']
})
export class AddNewReviewCommentComponent {

    id: string;

    isHidden: boolean;
    checkedRoles: number[] = [];

    public href = '';
  isAdding = false;

    searchText: any;

    form = new FormGroup({
        title: new FormControl('', Validators.required),
        description: new FormControl('', Validators.required),
        nickname: new FormControl('', Validators.required),
    });

    constructor(private router: Router,
                private customerService: MagentoCustomerService,
                private route: ActivatedRoute,
                private registry: RegistryService,
                private reviewService: ReviewsService,
                private dialogRef: MatDialogRef<AddNewReviewCommentComponent>,
                @Inject(MAT_DIALOG_DATA) public data: any
    ) {


    }


    ngOnInit() {

        this.id = this.data.id;

    }


    close() {

        this.dialogRef.close();
    }

    createComment() {

        if (this.form.valid) {

            let customer = this.registry.customer;
            let reviewCommentObj = {
                'product_id': this.data.product.id,
                'store_id': environment.store_id,
                'title': this.form.value.title,
                'detail': this.form.value.description,
                'nickname': this.form.value.nickname,
                'customer_id': null

            };
            if(customer){

                reviewCommentObj.customer_id = customer.id

            }

            this.isAdding = true;
            this.reviewService.addNewProductReview(reviewCommentObj).subscribe(response => {

                this.reviewService.EmitNewCommentAdded(true);


              this.isAdding = false;
              this.dialogRef.close();

            })




        } else {
            Object.keys(this.form.controls).forEach(field => {
                const control = this.form.get(field);
                control.markAsTouched({onlySelf: true});
            });


        }


    }


}
